import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { CommonService } from '../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-gestion-document',
  templateUrl: './gestion-document.component.html',
  styleUrls: ['./gestion-document.component.css']
})
export class GestionDocumentComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() bon;
  @Input() type;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  showSpinner: Boolean = false;
  filename = '';
  i = 0;
  loadingIndicator: Boolean = false;
  deleteElm = [];
  error = '';
  listeTypeDoc : any[] = [];
  isEcobennesRDB: Boolean = false;
  modalImageSrc = '';

  @ViewChild('msg') msg;
  @ViewChild('modalPdf') modalPdf;
  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.type = this.type || (this.common.typeDoc !== '' ? this.common.typeDoc : this.type);
    this.listeTypeDoc =  [{id:0, libelle : "Autre", libelleObjetEntite : 'Autre'} ,  ...this.common.getType('listeTypeDoc')]
    this.listeTypeDoc.forEach(el => {
      el.libelleObjetEntite = el.libelle || ''
    });
    const url = window.location.href;
    if (url.includes('ecobennes/retour_bons')) {
      this.isEcobennesRDB = true;
    }

    if (!this.data.length) {
      this.common.afficherBtnDownloadAll = false;
    }
  }
  ngOnDestroy () {
    console.log('type')
    this.common.showTypeFile = false;
  }

  addLigne() {
    this.data.push({oTypeDocAssocie: {id:0, libelle : "Autre", libelleObjetEntite : 'Autre'} });
    this.data = [...this.data];
  }

  deleteLigne(row) {
    if (row.id) {
      this.deleteElm.push(row);
      this.deleteElm = [...this.deleteElm];
    }
    const temp = this.data.filter(elt => elt !== row);
    this.data = temp;
  }

  close() {
    this.common.isHisto = false;
    this.hidefunction.emit();
  }

  valide() {
    this.common.isHisto = false;
    this.showSpinner = true;
    // Gérer les fichiers vides (lignes qui n'ont pas de fichier rattaché
    const dataTmp = [];
    this.data.forEach(element => {
      if (!element.id) {
        element.id = 0;
      }

      if (element['id'] === 0 && (!element['nomFichier'] || !element['contentBase64'])) {
        // ne pas ajouter
      } else {
        dataTmp.push(element);
      }
    });
    this.data = dataTmp;

    switch (this.type) {
      case 'bon':
        console.log('bon');
        this.saveDocBon();
        break;
      default:
        console.log('Devis');

        // const dataTmp = [];
        this.data.forEach(element => {
          element.nomclass = 'FileObject';
          if (!element.id) {
            element.id = 0;
          }

          /*
          if(element['id'] == 0 && !element['nomFichier']) {
              // ne pas ajouter
          } else {
              dataTmp.push(element);
          }
          */
        });

        // Enlever les ajouts qui n'ont pas de fichier
        // this.data = dataTmp;

        this.saveDocDevis(this.data);
    }
    // this.showSpinner = false;
  }

  /*
   * event : reçu de l'input
   * row : la ligne ajouté
   */
  getNameFile(event, row) {
    const files = event.target.files;

    // Autoriser multidocument chargé en même temps
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (i == 0) {
        // Une ligne vide a été déjà ajouté
        this.readFile(file, row);
      } else {
        this.addLigne();
        const lastRow = this.data[this.data.length - 1];
        this.readFile(file, lastRow);
      }
    }
  }

  /**
   * Traduit le fichier dans $event <input> vers un objet FileObject pour java
   * file : depuis event.target.files
   * item : FileObject
   */
  readFile(file, item) {
    if (!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);
      this.deleteLigne(item);
      return;
    }

    item.nomFichier = file.name;
    item.description = file.name;

    const fileReader = new FileReader();
    const ctrl = this;
    fileReader.onload = function () {
      const base64 = (<string>fileReader.result).split(',');
      console.log(base64)
      item.contentBase64 = base64[1];
      item.fileReader = fileReader.result;
    };

    fileReader.readAsDataURL(file);
  }

  openDoc(row) {
    switch (this.type) {
      case 'bon':
        console.log('bon');
        this.openDocBon(row);
        break;
      default:
        console.log('Devis');
        this.openDocDevis(row);
    }
  }

  openDocDevis(row) {
    const param = {
      'servlet': 'DBGestionDocPieceEcorec',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'NOM_FICHIER': row.nomFichier,
        'USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.common.openFile(datas.data[0]);
    });
  }

  openDocBon(row) {
    const param = {
      'servlet': 'DBImprimerDocuments',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'ID_DOC_BON': {
          'typeParam': 'int',
          'valeur': row.id
        },
        'IS_DOC_LOCATION': {
          'typeParam': 'boolean',
          'valeur': false
        }
      }
    };
    if (row.fileReader && this.isEcobennesRDB) {
      this.modalImageSrc = row.fileReader + '#toolbar=0&navpanes=0&scrollbar=0';
      this.common.openModalDmdEcoGED(this.modalService, this.modalPdf);
      $('#my-container').height($(window).height() - 200);
    } else {
      this.common.post('', { param: param }).then(datas => {
        if (this.isEcobennesRDB) {
          const url = this.common.intercept(datas.data[0]);
          this.modalImageSrc = url + '#toolbar=0&navpanes=0&scrollbar=0';
          this.common.openModalDmdEcoGED(this.modalService, this.modalPdf);
          $('#my-container').height($(window).height() - 200);
        } else {
          this.common.openFile(datas.data[0]);
        }
      });
    }
  }

  onActivate(event) {
    if (event.type === 'dblclick') {
      if (event.row.id !== 0) {
        this.openDoc(event.row);
      }
    }
  }

  saveDocDevis(doc) {
    delete doc.fileReader;
    const param = {
      'servlet': 'DBGestionDocPieceEcorec',
      'module': 'Recylog',
      'clefTypeDocPieceEcorec': this.common.clefTypeDocPieceEcorec,
      'clefPieceEcorec': this.common.idPiece,
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_PIECE_ECOREC': {
          'typeParam': 'int',
          'valeur': this.common.idPiece
        },
        'CLEF_TYPE_DOC_PIECE_ECOREC': {
          'typeParam': 'int',
          'valeur': this.common.clefTypeDocPieceEcorec
        },
        'DOCS': doc
      }
    };
    this.common.post('', { param: param }, true).then(datas => {
      this.showSpinner = false;
      this.common.closeModal();
    });
  }

  /*saveDoc(doc) {
    doc.forEach(elt => {
      if (!elt.id) {
        const param = {
          'servlet': 'DBGestionDocPieceEcorec',
          'module': 'Recylog',
          'clefTypeDocPieceEcorec': 1,
          'clefPieceEcorec': this.common.idPiece,
          'contenu': elt.contentBase64,
          'nomFichier': elt.nomFichier,
          'description': elt.description,
        };
        console.log(param);
        this.common.sendDoc('', param).then(datas => {
          this.common.closeModal();
        });
      }
    });
  }*/

  saveDocBon() {
    const prom = [];
    if (this.deleteElm.length) {
      this.deleteElm.forEach(elt => {
        const fct = this.deleteDocBon(elt);
        prom.push(fct);
      });
    }
    const add = this.data.filter(elt => !elt.id);
    if (add.length) {
      add.forEach(elt => {
        elt.id = 0;
        const fct = this.addDocBon(elt);
        prom.push(fct);
      });
    }

    Promise.all(prom).then(data => {
      console.log(data)
      if (data.length) {
        this.validefunction.emit(this.bon);
      }
      this.common.doSomethingAfterCloseDoc.next(this.data);
      this.showSpinner = false;
      this.common.closeModal();

    }).catch(error => {
      this.common.doSomethingAfterCloseDoc.next(this.data);
      this.showSpinner = false;
      this.common.closeModal();
      this.error = error;
      this.common.openModal(this.modalService, this.msg);
    });
  }

  addDocBon(doc) {
    delete doc.fileReader;
    doc['clefObjetParent'] = this.bon ? this.bon['id'] : this.common.idPiece;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  deleteDocBon(doc) {
    doc['clefObjetParent'] = this.bon ? this.bon['id'] : this.common.idPiece;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  downloadAll() {
    const param = {
      'servlet': 'DBImprimerDocuments',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 11
        },
        'CLEF_PIECE': {
          'typeParam': 'int',
          'valeur': this.common.idPiece
        },
        'CLEF_MODULE': {
          'typeParam': 'int',
          'valeur': this.common.activedModule || 0
        },
        'CLEF_TYPE_DOC_PIECE_ECOREC': {
          'typeParam': 'int',
          'valeur': this.common.clefTypeDocPieceEcorec || 0
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.isEcobennesRDB) {
        this.common.forceDown(datas.data[0]);
      } else {
        this.common.openFile(datas.data[0]);
      }

    });
  }

}
